import { useQuery } from '@tanstack/react-query'

import { fetchVenueRevenueDashboard } from '@/lib/venue/revenueApi'
import type { VenueRevenueDashboardView } from '@/lib/venue/revenueTypes'

export function venueRevenueDashboardQueryKey(venueId: string) {
  return ['venue', venueId, 'revenues', 'dashboard'] as const
}

export function useVenueRevenueDashboard(venueId: string) {
  return useQuery<VenueRevenueDashboardView>({
    queryKey: venueRevenueDashboardQueryKey(venueId),
    queryFn: () => fetchVenueRevenueDashboard(venueId),
  })
}
